import React, { useState,useEffect } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import RRtestCenterImg from "../../images/RRtestCenterImg.png";
import { AthleteHeader } from "../common/AthleteHeader";
import { useNavigate } from 'react-router-dom';



export const AthleteLoadvelocityTestStep4 = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
 

  const [maxSpeed4, setMaxSpeed4] = useState(0); // State for max speed
  const [load4, setLoad4] = useState(0);
  const [error, setError] = useState(""); // State for error message
  const [athleteWeight, setAthleteWeight] = useState(null);
  const [isEditingWeight, setIsEditingWeight] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // Restore data from sessionStorage
    const maxSpeed4_ = sessionStorage.getItem('lvmaxSpeed4');
    if (maxSpeed4_) setMaxSpeed4(maxSpeed4_);
  }, []);

  useEffect(()=>{
    const load4 = (75 * athleteWeight) / 100;
    setLoad4(load4);
  },[athleteWeight]);

  useEffect(() => {
    const fetchAthleteWeight = async () => {
      try {
        const response = await fetch(`${API_URL.GET_ATHLETE_BY_ID_FRONT}/${athlete.id}`, {
          headers: { Authorization: `Bearer ${athlete.token}` },
        });

        if (!response.ok) throw new Error("Failed to fetch athlete weight");

        const data = await response.json();
        setAthleteWeight(data.weight);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchAthleteWeight();
  }, [athlete.id, athlete.token]);

  const handleSaveWeight = async () => {
    if (!athleteWeight || isNaN(athleteWeight) || Number(athleteWeight) <= 0) {
      setError("Please enter a valid weight.");
      return;
    }

    try {
      setSaving(true); // Show loading state
      const response = await fetch(`${API_URL.UPDATE_ATHLETE_DETAILS_BY_ID_FRONT}${athlete.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${athlete.token}`,
        },
        body: JSON.stringify({ weight: athleteWeight }),
      });

      if (!response.ok) throw new Error("Failed to update weight");

      setIsEditingWeight(false);
    } catch (err) {
      setError(err.message);
    }
    finally {
      setSaving(false);
    }
  };
  

  const handleSaveMaxSpeed = () => {
    if (!maxSpeed4|| isNaN(maxSpeed4) || Number(maxSpeed4) <= 0) {
      setError("Please enter a valid positive number.");
      return;
    }
    // Save to session storage and clear errors
    sessionStorage.setItem("lvmaxSpeed4", maxSpeed4);
    setError(""); // Clear any existing errors
    alert("Computing test results...");
    navigate('/athlete/tools/loadvelocity/test/result');
  };

  return (
    <AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>
      <div className="relative h-full bg-[#f6f6f6] testbg pb-5 overflow-y-auto">

        


        <div className="bg-[#F6F6F6]">
          <div className="w-full max-w-2xl mx-auto flex flex-row justify-between gap-5 px-10 py-[19px]">
            <span className={`text-base font-normal pb-[4px] text-black border-b border-black`}>
              Test
            </span>
            <span className={`text-base font-normal pb-[4px] text-[#a5a5a5]`}>
              Train
            </span>
            <span className={`text-base font-normal pb-[4px] text-[#a5a5a5]`}>
              Performance
            </span>
          </div>
        </div>

        <div className="w-full max-w-2xl mx-auto px-5 pb-5">
          <div className="relative text-center mb-[58px]">
            <p className="text-black text-base font-normal">Step 4</p>
                <div  onClick={() => navigate(-1)} className="absolute left-0 top-1/2 -translate-y-1/2 flex items-center gap-2 cursor-pointer">
                <ArrowL />
                <span className="text-black text-sm font-normal">Back</span>
                </div>
          </div>
          <span  className="mx-auto w-fit block mb-[30px]">
            <div style={{ width: 174, height: 174 }}>
              <CircularProgressbarWithChildren
                strokeWidth={5}
                value={100}
                styles={buildStyles({
                  textColor: "#000", // Text color
                  pathColor: "#00901E", // Progress path color
                  trailColor: "#E5E5E5", // Background path color
                })}
              >
                <img
                  src={RRtestCenterImg}
                  alt="testCenterImg"
                  className="w-[92px] h-[68px] mb-2"
                />
                <span className="text-black text-[12px] font-normal leading-[91%] uppercase">
                  load velocity
                </span>
              </CircularProgressbarWithChildren>
            </div>
          </span>

             {/* Top Right Athlete Weight */}
             <div className="flex flex-row justify-center gap-2">
          <span className="text-black text-sm font-semibold">Weight:</span>
          {isEditingWeight ? (
            <>
            <input
              type="text"
              value={athleteWeight}
              onChange={(e) => setAthleteWeight(e.target.value)}
              className="border-b border-black text-black text-sm w-16 outline-none"
              autoFocus
            />
            <button onClick={handleSaveWeight} className="text-[#00901E] text-xs">
              {saving ? "Saving..." : "Save"}
            </button>
          </>
        ) : (
          <>
            <span className="text-black text-sm">{athleteWeight} lbs</span>
            <button onClick={() => setIsEditingWeight(true)} className="text-[#00901E] text-xs">
              Edit
            </button>
          </>
        )}
        </div>

        <br/>      

          <div className="flex flex-col gap-2 mb-10">
            <div className="flex flex-row justify-center gap-12">
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">REPS</p>
                <p className="text-black text-sm font-normal">1</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">Distance</p>
                <p className="text-black text-sm font-normal">15m</p>
              </div>
              <div className="space-y-2 text-center">
                <p className="text-[#a5a5a5] text-xs font-normal uppercase">LOAD</p>
                <p className="text-black text-sm font-normal">{load4}</p>
              </div>
            </div>
            <div className="relative w-full max-w-[244px] border-b border-black mx-auto">
              <input
                type="text"
                placeholder="Enter max speed"
                className="bg-transparent w-full outline-none p-[19px_60px_19px_20px] placeholder:text-[#A5A5A5] text-black text-xl font-normal"
                value={maxSpeed4}
                onChange={(e) => setMaxSpeed4(e.target.value)}
              />
              <button
                className="absolute right-5 top-1/2 -translate-y-1/2 bg-[#00901E] text-white p-2 rounded-full"
                onClick={handleSaveMaxSpeed}
              >
                <Add />
              </button>
            </div>
            {error && <p className="text-red-500 text-sm mt-2 text-center">{error}</p>}
          
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Add = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
